import type { FeatureFlag } from '@enums/featureFlag.ts';

export const hasFeatureFlag = (featureFlag: FeatureFlag): boolean => window.featureFlag[featureFlag] ?? false;
